// The name next-intl also uses for a remembered locale.
export const LOCALE_COOKIE = "NEXT_LOCALE";

// One year — a language preference should outlive a browsing session.
export const LOCALE_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;
